import React from "react";

const WhiteLabelContext = React.createContext({
  app: "ClimateAI" | "Skip",
});

export default WhiteLabelContext;
